import React from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  ArrowRight, Activity, Lock, Shield, Map as MapIcon,
  Newspaper, TrendingUp, Wheat,
} from "lucide-react";
import Logo from "../components/Logo";
import { useAuth } from "../lib/AuthContext";

export default function Landing() {
  const navigate = useNavigate();
  const { isAuthed } = useAuth();
  const target = isAuthed ? "/dashboard" : "/login";

  return (
    <div className="landing-page" data-testid="landing-page">
      <div className="landing-bg-grid" />
      <div className="landing-bg-glow" />

      <header className="landing-nav">
        <Link to="/" className="landing-brand" data-testid="landing-brand">
          <Logo size={42} />
          <div>
            <div className="lb-title">NATIONAL &amp; MONITORING SYSTEM</div>
            <div className="lb-sub">Republik Indonesia</div>
          </div>
        </Link>
        <div className="landing-nav-right">
          <span className="landing-status">
            <Activity size={12} /> SISTEM AKTIF
          </span>
          <button
            className="landing-cta-sm"
            onClick={() => navigate(target)}
            data-testid={isAuthed ? "landing-to-dashboard" : "landing-to-login"}
            type="button"
          >
            {isAuthed ? "MASUK DASHBOARD" : "LOGIN"}
            {isAuthed ? <ArrowRight size={14} /> : <Lock size={13} />}
          </button>
        </div>
      </header>

      <section className="landing-hero centered">
        <div className="landing-hero-inner">
          <div className="landing-tag">
            <span className="dot" /> SISTEM INTELIJEN PEMANTAUAN NASIONAL
          </div>
          <h1 className="landing-h1">
            Pantau Kondisi <span className="accent-cyan">Nasional</span> dari{" "}
            <span className="accent-emerald">Satu Layar</span>.
          </h1>
          <p className="landing-lede">
            Platform <strong>intelijen pemantauan terintegrasi</strong> untuk pengambilan
            keputusan strategis tingkat negara — mencakup risiko wilayah, kamtibmas,
            harga pangan strategis, sentimen media, serta rekomendasi berbasis AI di
            seluruh 38 provinsi Republik Indonesia.
          </p>

          <div className="landing-mini-features" aria-hidden="true">
            <span><Shield size={14} /> Risiko Wilayah</span>
            <span><MapIcon size={14} /> Geospasial 38 Provinsi</span>
            <span><Wheat size={14} /> Harga Pangan</span>
            <span><Newspaper size={14} /> Sentimen Media</span>
            <span><TrendingUp size={14} /> Makroekonomi</span>
          </div>

          <div className="landing-cta-row">
            <button
              className="landing-cta-primary"
              onClick={() => navigate(target)}
              data-testid="landing-cta-primary"
              type="button"
            >
              {isAuthed ? "MASUK DASHBOARD" : "MASUK SISTEM"} <ArrowRight size={16} />
            </button>
          </div>

          <div className="landing-stats">
            <div className="ls-stat"><strong>38</strong><span>PROVINSI</span></div>
            <div className="ls-stat"><strong>321</strong><span>PORTAL MEDIA</span></div>
            <div className="ls-stat"><strong>12</strong><span>KOMODITAS</span></div>
            <div className="ls-stat"><strong>24/7</strong><span>REAL-TIME</span></div>
          </div>
        </div>
      </section>

      <footer className="landing-foot">
        <span>© 2026 National &amp; Monitoring System · Republik Indonesia</span>
        <span className="landing-foot-meta">Dibangun untuk kebijakan berbasis data</span>
      </footer>
    </div>
  );
}
